/* eslint-disable eslint-comments/disable-enable-pair -- skeleton */
/* eslint-disable @typescript-eslint/no-deprecated -- skeleton */
import { Skeleton } from "@tql/ui-components-react/kendo/indicators";
import { useContext } from "react";

import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";
import {
	useGetCustomerAr,
	useGetCustomerCredit,
} from "~/features/quote/hooks/use-quote-details-hooks.ts";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

import styles from "./customer-details-bar.module.css";

type CustomerDetailsBarProps = Readonly<{
	isParentLoading: boolean;
}>;

export function CustomerDetailsBar({
	isParentLoading,
}: CustomerDetailsBarProps) {
	const { quoteState } = useContext(QuoteDetailsContext);

	const customerId = quoteState?.customer?.id ?? 0;
	const brokerId = quoteState?.customer?.primaryBroker?.id ?? 0;
	const statusName = quoteState.customer?.status?.name || "";
	const primaryBrokerName = quoteState.customer?.primaryBroker?.name || "";
	const ltlTermsValue = quoteState.customer?.hasSignedLTLAddendum
		? "Yes"
		: "No";

	const { creditInfo, isLoading: creditInfoLoading } =
		useGetCustomerCredit(customerId);
	const { arInfo, isLoading: arInfoLoading } = useGetCustomerAr(
		customerId,
		brokerId,
	);

	const isCustomerDataStale =
		customerId > 0 &&
		(quoteState?.customerDetails?.id ?? 0) > 0 &&
		quoteState?.customerDetails?.id !== customerId;

	const isLoading =
		isParentLoading ||
		creditInfoLoading ||
		arInfoLoading ||
		isCustomerDataStale;

	const arName = arInfo?.name || "None Assigned";
	const availableCredit = creditInfo?.availableCredit ?? 0;
	return (
		<div className={styles.customerDetailsBar}>
			<div className={styles.customerDetails}>
				<div>
					<div>Status</div>
					<div className={styles.customerInfoContent}>
						{isLoading ? <Skeleton style={{ width: 75 }} /> : statusName}
					</div>
				</div>
				<div>
					<div>LAE</div>
					<div className={styles.customerInfoContent}>
						{isLoading ? <Skeleton style={{ width: 75 }} /> : primaryBrokerName}
					</div>
				</div>
				<div>
					<div>AR</div>
					<div className={styles.customerInfoContent}>
						{isLoading ? <Skeleton style={{ width: 75 }} /> : arName}
					</div>
				</div>
				<div className={"customer-info-field"}>
					<div>LTL Terms</div>
					<div className={styles.customerInfoContent}>
						{isLoading ? <Skeleton style={{ width: 75 }} /> : ltlTermsValue}
					</div>
				</div>
			</div>

			<div className={styles.availableCredit}>
				<div>Available Credit</div>

				{isLoading ? (
					<Skeleton style={{ width: "100%" }} />
				) : (
					<span className={styles.credit}>
						{formatCurrency(availableCredit)}
					</span>
				)}
			</div>
		</div>
	);
}
